import { StatsForNerdsStore } from '../store';
import { initializeStatsForNerds } from '../';
/**
 * Mixin to render Stats for Nerds in the Web Player.
 * This Mixin is not applied to the WebPlayer, because it depends on
 * DOM APIs which are not available in every React Native platform,
 * where the WebPlayer can be used.
 */
export const WithStatsForNerdsWebRenderer = (Base) => {
    return class extends Base {
        #cleanupStatsForNerds = null;
        #statsForNerdsStore = new StatsForNerdsStore();
        setView(view) {
            this.#statsForNerdsStore.player = this;
            this.#cleanupStatsForNerds = initializeStatsForNerds({
                statsForNerdsStore: this.#statsForNerdsStore,
                view,
            });
            super.setView(view);
        }
        destroy() {
            this.#cleanupStatsForNerds?.();
            this.#cleanupStatsForNerds = null;
            return super.destroy();
        }
    };
};
